import { useEffect, useState } from "react";

import moment from 'moment';

import { Collapsible, CollapsibleContent } from "@shadcn/components/ui/collapsible";
import { Input } from '@shadcn/components/ui/input'

import { Card, CardContent as CardBody, CardHeader } from '@shadcn/components/ui/card';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Editable
import { useHistory } from "react-router-dom";
import superagent from 'superagent'

//Import Breadcrumb

import useQuery from '../../../helpers/JIFI/useQuery';
import { backendUrl } from '../../../helpers/consts.js'
import EditAddressModal from '../../../components/shared/EditAddressModal';


import { CSVReader } from 'react-papaparse';
import { CSVLink } from "react-csv";
import SupplyChainNav from "../../../components/supply-chain/nav.js";
import CommentHostory from "../../Skote/Dashboard/CommentHistory.js";
import ProductVariantSelector from "../helpers/ProductVariantSelector.js";
import { Row } from "@shadcn/components/ui/row";
import { Col } from "@shadcn/components/ui/col";
import { Button } from "@shadcn/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@shadcn/components/ui/dialog";
import { CustomInput } from "../purchase-orders";

const emptyAddress = {
  address1: '',
  address2: '',
  phone: '',
  city: '',
  zip: '',
  country: 'Australia',
  company: '',
  province: 'Victoria',
};


export const Accordian = ({ children, title, close }) => {
  const [open, setOpen] = useState(false)
  useEffect(() => {
    if (close === true) {
      setOpen(false)
    }
  }, [close])
  return (
    <>
      <div id="accordion">
        <Card className="mb-1">
          <CardHeader onClick={() => setOpen(prev => !prev)} className="p-3 bg-[#f6f6f6] border-b-0 border-b-[#f6f6f6] font-medium" id="headingOne">
            <h6 className="m-0 font-14">
              <span
                style={{ cursor: "pointer" }} className={''}>
                {title}
              </span>
            </h6>
          </CardHeader>
          <Collapsible open={open} onOpenChange={() => setOpen(prev => !prev)}>
            <CollapsibleContent>
              <Card>
                <CardBody>
                  {children}
                </CardBody>
              </Card>
            </CollapsibleContent>
          </Collapsible>
        </Card>
      </div>
      <br /><br />
    </>
  )
}

const StockInput = ({ stock, setStock, productData }) => {
  const handleAddRow = () => {
    const prefillProduct = stock[stock.length - 1]?.product
    let prefillVariant
    if (prefillProduct) {
      prefillVariant = productData.find(val => prefillProduct === val._id)['variants'][0]
    }
    const item = {
      product: prefillProduct || productData[0]._id,
      variant: prefillVariant?._id || productData[0]['variants'][0]._id,
      sku: prefillVariant?.sku || productData[0]['variants'][0].sku,
      manufacturingLeadTime: 0,
      currentFOB: 0
    };

    setStock(prev => [...prev, item])
  };

  const editVariantRow = (id, val) => {
    setStock(prev => {
      let newList = [...prev]


      const variantId = typeof val === 'string' ? val : val?._id



      const newProduct = productData.find(prod => prod.variants.find(vari => vari._id === variantId))
      const newVariant = newProduct?.variants.find(vari => vari._id === variantId)



      newList[id]['product'] = newProduct?._id
      newList[id]['variant'] = variantId
      newList[id]['manufacturingLeadTime'] = 0
      newList[id]['currentFOB'] = 0
      newList[id]['sku'] = newVariant?.sku



      return newList
    })
  };

  const editManufacturingLeadTimeRow = (id, val) => {
    setStock(prev => {
      let newList = [...prev]
      let parsedInput = parseInt(val)
      if (parsedInput < 0) {
        parsedInput = 0
      }
      newList[id]['manufacturingLeadTime'] = parsedInput
      return newList
    })
  };

  const editCurrentFOBRow = (id, val) => {
    setStock(prev => {
      let newList = [...prev]
      let parsedInput = parseFloat(val)
      if (parsedInput < 0) {
        parsedInput = 0
      }
      newList[id]['currentFOB'] = parsedInput
      return newList
    })
  };


  const removeRow = (id) => {
    setStock(prev => {
      let newList = prev.filter((item, key) => key !== id)
      return newList
    })
  };

  const products = productData ? productData.map(product => {
    const variants = product.variants.map(variant => {
      return {
        _id: variant._id,
        name: variant.name,
        selected: stock.findIndex(val => val.variant === variant._id)
      }
    })

    return {
      name: product.name,
      _id: product._id,
      variants
    }
  }) : []

  return <>
    <Row className="gap-4">
      <Col className="sm:w-4/12">
        Variant
      </Col>
      <Col className="sm:w-2/12">
        Manufacturing Lead Time
      </Col>
      <Col className="sm:w-2/12">
        Current FOB
      </Col>
    </Row>
    {
      productData && stock.map((line, lineKey) => {

        const variantId = typeof line.variant === 'string' ? line.variant : line.variant?._id
        let selectedVariantObj = null

        if (variantId && Array.isArray(productData)) {
          for (const product of productData) {
            const foundVariant = product.variants?.find(v => v._id === variantId)
            if (foundVariant) {
              selectedVariantObj = {
                ...foundVariant,
                sku: line.sku || foundVariant.sku
              }
              break
            }
          }
        }



        return (
          <Row className="gap-4" style={{ padding: '12px 0' }}>
            <Col className="sm:w-4/12" >
              <ProductVariantSelector
                products={products}
                setSelectedVariant={(val) => {
                  editVariantRow(lineKey, val)
                }}
                selectedVariant={selectedVariantObj}
              />

            </Col>
            <Col className="sm:w-2/12">
              <CustomInput
                value={stock[lineKey]['manufacturingLeadTime']}
                onChange={(e) => editManufacturingLeadTimeRow(lineKey, e.target.value)}
                isPrefix={false}
                preSufix="days"
              ></CustomInput>

            </Col>
            <Col className="sm:w-2/12">
              <CustomInput
                value={stock[lineKey]['currentFOB']}
                onChange={(e) => editCurrentFOBRow(lineKey, e.target.value)}
                isPrefix={true}
              ></CustomInput>
            </Col>
            <Col className="sm:w-1/12">
              <Button onClick={() => removeRow(lineKey)} variant="destructive">
                X
              </Button>{" "}
            </Col>
          </Row>
        )
      })
    }
    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: 12 }}>
      <Button onClick={handleAddRow} variant="primary">
        Add{" "}
      </Button>{" "}
      <span />
    </div>
  </>
}

const FactoryPage = ({
  match: {
    params
  }
}) => {
  const { factoryID } = params

  const [name, setName] = useState('')
  const [code, setCode] = useState('')
  const [variantLines, setVariantLines] = useState([])
  const [address, setAddress] = useState(emptyAddress)
  // Supplier master fields (Phase 1)
  const [contacts, setContacts] = useState([])
  const [defaultCurrency, setDefaultCurrency] = useState('')
  const [defaultIncoterm, setDefaultIncoterm] = useState('')
  const [paymentTermsDays, setPaymentTermsDays] = useState('')
  const [addressEditModal, setAddressEditModal] = useState(false)
  const [releaseCsv, setReleaseCsv] = useState(null)
  const [releaseError, setReleaseError] = useState(null)
  const [submittingRelease, setSubmittingRelease] = useState(false)
  const [releaseSyncSummary, setReleaseSyncSummary] = useState(null)
  const [isReleaseSummaryOpen, setIsReleaseSummaryOpen] = useState(false)

  const history = useHistory();
  const [loadingSave, setLoadingSave] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const refreshData = () => setRefresh(prev => !prev)

  const toDateInputValue = (rawValue) => {
    const value = (rawValue ?? '').trim()
    if (!value) return ''

    const parsed = moment(value, ['YYYY-MM-DD', 'MM/DD/YYYY', 'DD/MM/YYYY', 'DD-MM-YY', 'D/M/YYYY', 'DD-MMM-YY', 'DD-MMM-YYYY'], true)

    if (!parsed.isValid()) {
      return ''
    }


    return parsed.format('YYYY-MM-DD')
  }

  const isValidNumericInput = (value) => {
    if (value === '') return true
    return /^\d+(\.\d+)?$/.test(value)
  }

  const [factory, factoryState] = useQuery({
    url: `/factory/${factoryID}`
  });
  const [productData, productState] = useQuery({
    url: `/product`,
    refresh
  });

  useEffect(() => {
    if (factory) {


      setName(factory.name)
      setCode(factory.code)
      setAddress(factory.address || emptyAddress)
      setContacts(factory.contacts || [])
      setDefaultCurrency(factory.defaultCurrency || '')
      setDefaultIncoterm(factory.defaultIncoterm || '')
      setPaymentTermsDays(
        factory.paymentTermsDays != null ? String(factory.paymentTermsDays) : '',
      )

      const processedLines = factory.variantLines.map((line, idx) => {

        const processed = {
          ...line,
          variant: line.variant,
          sku: line.sku || line.variant?.sku
        }

        return processed
      })

      setVariantLines(processedLines)

    }
  }, [factory])


  const handleSave = (e) => {
    e.preventDefault()
    if (loadingSave === true) return


    if (!name?.trim()) {
      toast.error('Factory name is required');
      return;
    }

    if (!code?.trim()) {
      toast.error('Factory code is required');
      return;
    }

    const cleanedVariantLines = variantLines.map(line => {
      const { stockOnHand, ...rest } = line
      return rest
    })

    setLoadingSave(true)
    if (factoryID === 'create') {
      superagent.post(`${backendUrl}/factory/create`)
        .send({
          name: name,
          code: code,
          address: address,
          contacts: contacts,
          defaultCurrency: defaultCurrency || undefined,
          defaultIncoterm: defaultIncoterm || undefined,
          paymentTermsDays: paymentTermsDays !== '' ? Number(paymentTermsDays) : undefined,
          variantLines: cleanedVariantLines
        })
        .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
        .set('accept', 'json')
        .then(response => {
          setLoadingSave(false);
          const statusCode = response.status
          if (statusCode > 400) {

            const errorMessage = response.body?.message || response.body?.response?.message || 'An error occurred';
            toast.error(errorMessage);
          } else {
            history.push(`/factories/${response.body._id}`)
          }
        })
        .catch(err => {
          setLoadingSave(false);
          console.log(err);

          const errorMessage = err?.response?.body?.message || err?.response?.body?.response?.message || err?.message || 'An error occurred';
          toast.error(errorMessage);
        });
    } else {
      superagent.put(`${backendUrl}/factory/update/${factoryID}`)
        .send({
          name: name,
          code: code,
          address: address,
          contacts: contacts,
          defaultCurrency: defaultCurrency || undefined,
          defaultIncoterm: defaultIncoterm || undefined,
          paymentTermsDays: paymentTermsDays !== '' ? Number(paymentTermsDays) : undefined,
          variantLines: cleanedVariantLines
        })
        .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
        .set('accept', 'json')
        .then(response => {
          setLoadingSave(false);
          const statusCode = response.status
          if (statusCode > 400) {

            const errorMessage = response.body?.message || response.body?.response?.message || 'An error occurred';
            toast.error(errorMessage);
          }
        })
        .catch(err => {
          setLoadingSave(false);
          console.log(err);

          const errorMessage = err?.response?.body?.message || err?.response?.body?.response?.message || err?.message || 'An error occurred';
          toast.error(errorMessage);
        });
    }
  }

  const normalizeReleaseRow = (row, length) => {
    return Array.from({ length }, (_, index) => {
      const cell = row?.[index]
      if (cell === undefined || cell === null) return ''
      return `${cell}`.trim()
    })
  }

  const parseReleaseCsv = (rows) => {
    const validRows = rows
      .map((entry) => entry?.data ?? [])
      .map((row) => row.map((cell) => (cell === undefined || cell === null ? '' : `${cell}`)))
      .filter((row) => row.some((cell) => `${cell}`.trim() !== ''))

    if (validRows.length < 2) {
      throw new Error('CSV must include at least the header row and the Delivery Date row')
    }

    const headers = validRows[0].map((cell) => `${cell}`.trim())
    const columnCount = headers.length
    if (columnCount === 0) {
      throw new Error('Could not find a valid header in the CSV')
    }

    const deliveryRow = normalizeReleaseRow(validRows[1], columnCount).map((cell, index) => {
      if (index === 0) {
        return cell || 'Delivery Date'
      }

      if (index === 1) {
        return cell
      }

      const formatted = toDateInputValue(cell)
      return formatted || ''
    })

    const dataRowsRaw = validRows.slice(2)
    if (dataRowsRaw.length === 0) {
      throw new Error('CSV must contain at least one SKU row')
    }
    const dataRows = dataRowsRaw.map((row) => normalizeReleaseRow(row, columnCount))

    return {
      headers,
      deliveryRow,
      rows: dataRows,
    }
  }

  const handleReleaseCsvDrop = (data) => {
    try {
      const parsed = parseReleaseCsv(data)
      setReleaseCsv(parsed)
      setReleaseError(null)
    } catch (error) {
      setReleaseCsv(null)
      setReleaseError(error.message || 'Unable to parse the CSV')
    }
  }

  const handleReleaseCsvError = () => {
    setReleaseCsv(null)
    setReleaseError('Unable to read the CSV file. Please try again.')
  }

  const handleReleaseCsvRemove = () => {
    setReleaseCsv(null)
    setReleaseError(null)
  }

  const updateDeliveryCell = (columnIndex, value) => {
    setReleaseCsv((prev) => {
      if (!prev) return prev
      if (columnIndex === 0 || columnIndex === 1) return prev

      const nextDelivery = [...prev.deliveryRow]
      nextDelivery[columnIndex] = toDateInputValue(value)
      return {
        ...prev,
        deliveryRow: nextDelivery,
      }
    })
  }

  const updateReleaseCell = (rowIndex, columnIndex, value) => {
    setReleaseCsv((prev) => {
      if (!prev) return prev
      if (columnIndex === 0) return prev
      if (!isValidNumericInput(value)) return prev

      const nextRows = prev.rows.map((row, idx) => {
        if (idx !== rowIndex) return row
        const updatedRow = [...row]
        updatedRow[columnIndex] = value
        return updatedRow
      })
      return {
        ...prev,
        rows: nextRows,
      }
    })
  }

  const sanitizeText = (value) => `${value ?? ''}`.trim()

  const parseOptionalNumber = (value) => {
    const normalized = `${value ?? ''}`.trim()
    if (normalized === '') return undefined
    const numericValue = Number(normalized)
    if (Number.isNaN(numericValue)) return undefined
    return numericValue
  }

  const buildReleasePayload = (data, factoryCode) => {
    const items = data.rows
      .map((row) => {
        const sku = sanitizeText(row[0])
        if (!sku || sku === 'TOTAL') return null

        const stockOnHand = parseOptionalNumber(row[1])
        const purchaseOrders = []

        data.headers.forEach((header, index) => {
          if (index <= 1) return

          const reference = sanitizeText(header)
          if (!reference) return

          const remaining = parseOptionalNumber(row[index])

          if (remaining === undefined) return
          const expectedDeliveryDate = sanitizeText(data.deliveryRow[index])

          const purchaseOrder = { reference }
          if (remaining !== undefined) {
            purchaseOrder.remaining = remaining
          }
          if (expectedDeliveryDate) {
            purchaseOrder.expectedDeliveryDate = expectedDeliveryDate
          }

          purchaseOrders.push(purchaseOrder)
        })

        const item = {
          sku,
          purchaseOrders,
        }

        if (stockOnHand !== undefined) {
          item.stockOnHand = stockOnHand
        }

        return item
      })
      .filter(Boolean)

    return {
      factoryCode,
      items,
    }
  }

  const hasReleaseSuccess = Array.isArray(releaseSyncSummary?.successOrders) && releaseSyncSummary.successOrders.length > 0
  const hasReleaseFailures = Array.isArray(releaseSyncSummary?.failureItems) && releaseSyncSummary.failureItems.length > 0

  const openReleaseSyncSummary = (result) => {
    const responseBody = result && typeof result === 'object' ? result : null
    const successOrders = Array.isArray(responseBody?.successPurchaseOrders)
      ? responseBody.successPurchaseOrders
      : []
    const failureItems = Array.isArray(responseBody?.failures) ? responseBody.failures : []

    const normalizedSuccessOrders = successOrders.map((order) => ({
      reference: sanitizeText(order?.reference) || 'Unknown PO',
      skus: Array.isArray(order?.skus) ? order.skus.map((sku) => sanitizeText(sku)).filter(Boolean) : []
    }))

    const uniqueFailureItems = []
    const seenMessages = new Set()

    failureItems.forEach((item) => {
      const message = sanitizeText(item?.message)
      const fallback = [sanitizeText(item?.poReference), sanitizeText(item?.sku)].filter(Boolean).join(' - ')
      const key = message || fallback || 'Unknown failure'
      if (seenMessages.has(key)) return
      seenMessages.add(key)

      uniqueFailureItems.push({
        message: message || (fallback ? `Failed to sync ${fallback}` : 'Failed to sync purchase order'),
        poReference: sanitizeText(item?.poReference),
        sku: sanitizeText(item?.sku),
      })
    })

    setReleaseSyncSummary({
      factory: sanitizeText(responseBody?.factory) || sanitizeText(code),
      successOrders: normalizedSuccessOrders,
      failureItems: uniqueFailureItems,
    })
    setIsReleaseSummaryOpen(true)
  }

  const submitReleaseData = async () => {
    if (!releaseCsv) {
      toast.error('Please upload a CSV before submitting')
      return
    }

    const trimmedFactoryCode = sanitizeText(code)
    if (!trimmedFactoryCode) {
      toast.error('Factory code must not be empty')
      return
    }

    try {
      setSubmittingRelease(true)
      setReleaseSyncSummary(null)
      setIsReleaseSummaryOpen(false)
      const payload = buildReleasePayload(releaseCsv, trimmedFactoryCode)

      const response = await superagent
        .post(`${backendUrl}/factory/syncFactoryStockStatus`)
        .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
        .set('accept', 'json')
        .send(payload)

      openReleaseSyncSummary(response?.body)
      refreshData()
    } catch (error) {
      const statusCode = error?.status || error?.response?.status
      const errorMessage =
        error?.response?.body?.message ||
        error?.response?.body?.response?.message ||
        error?.message ||
        'Failed to sync purchase order release'

      if (statusCode && statusCode >= 500) {
        history.replace(history.location.pathname, {
          errorStatusCode: statusCode
        });
      } else {
        toast.error(errorMessage)
      }
      console.log(error)
    } finally {
      setSubmittingRelease(false)
    }
  }

  const handleOnDrop = (data) => {
    let items = []
    data.map((line, key) => {
      if (key > 0) {
        const manufacturingLeadTime = line.data[1]
        const currentFOB = line.data[2]

        const sku = line.data[0]

        let product = productData.data.find(val => (val.variants.find(variant => variant.sku === sku) != undefined))
        if (product != undefined) {
          let variant = product.variants.find(variant => variant.sku === sku)
          if (variant != undefined) {
            const item = {
              variant: variant,
              currentFOB: currentFOB,
              manufacturingLeadTime: manufacturingLeadTime,
              sku: sku
            };
            items.push(item)
          }
        }
      }
    })

    setVariantLines(prev => {
      let newVariantLines = [...prev]
      items.map(variantLine => {
        const alreadyExists = newVariantLines.find(oldVariantLine => oldVariantLine.product === variantLine.product && oldVariantLine.variant === variantLine.variant)
        if (!alreadyExists) {
          newVariantLines.push(variantLine)
        } else {
          alreadyExists['currentFOB'] = variantLine['currentFOB']
          alreadyExists['manufacturingLeadTime'] = variantLine['manufacturingLeadTime']
          alreadyExists['sku'] = variantLine['sku']
        }
      })

      return newVariantLines
    })
  };
  const handleOnError = (err) => {
    console.log(err)
  }
  const handleOnRemoveFile = (file) => {
    console.log(file)
  }



  const csvData = [
    ['SKU', 'Manufacturing Lead Time', 'Current FOB'],
    ...variantLines.map((variantLine, index) => {
      const rowData = {
        raw: variantLine,
        sku: variantLine.sku,
        variantSku: variantLine.variant?.sku,
        variantObject: variantLine.variant,
        manufacturingLeadTime: variantLine['manufacturingLeadTime'],
        currentFOB: variantLine['currentFOB']
      }

      return [
        variantLine.sku || variantLine.variant?.sku,
        variantLine['manufacturingLeadTime'],
        variantLine['currentFOB']
      ]
    })
  ]




  const [stockLevels, stockLevelsState] = useQuery({
    url: `/purchase-order/factory/${factoryID}`,
    refresh
  });



  return (
    <>
      <ToastContainer />
      <Dialog open={isReleaseSummaryOpen} onOpenChange={setIsReleaseSummaryOpen}>
        <DialogContent className="z-[1600] min-w-[80vw] overflow-hidden">
          <DialogHeader>
            <DialogTitle>Factory Stock Sync Summary</DialogTitle>
            <DialogDescription>
              {releaseSyncSummary?.factory ? `${releaseSyncSummary.factory} - Sync details` : 'Sync details'}
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-6 max-h-[60vh] overflow-y-auto pr-2">
            <section>
              <h4 className="text-lg font-medium mb-3">Successful Purchase Orders</h4>
              {hasReleaseSuccess ? (
                <div className="overflow-auto">
                  <table className="table table-bordered table-nowrap">
                    <thead>
                      <tr>
                        <th>Purchase Order</th>
                        <th>SKUs</th>
                      </tr>
                    </thead>
                    <tbody>
                      {releaseSyncSummary.successOrders.map((order, index) => (
                        <tr key={`release-success-${index}`}>
                          <td>{order.reference || 'Unknown PO'}</td>
                          <td>{order.skus.length > 0 ? order.skus.join(', ') : 'No SKUs'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p className="text-sm">No purchase orders were synced.</p>
              )}
            </section>
            <section>
              <h4 className="text-lg font-medium mb-3">Failed Items</h4>
              {hasReleaseFailures ? (
                <div className="overflow-auto">
                  <table className="table table-bordered table-nowrap">
                    <thead>
                      <tr>
                        <th>Message</th>
                        <th>Purchase Order</th>
                        <th>SKU</th>
                      </tr>
                    </thead>
                    <tbody>
                      {releaseSyncSummary.failureItems.map((item, index) => (
                        <tr key={`release-failure-${index}`}>
                          <td>{item.message}</td>
                          <td>{item.poReference || '-'}</td>
                          <td>{item.sku || '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p className="text-sm text-muted">All items synced successfully.</p>
              )}
            </section>
          </div>
          <DialogFooter className="flex justify-end">
            <Button type="button" variant="secondary" className="btn-md" onClick={() => setIsReleaseSummaryOpen(false)}>
              Close
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
      <SupplyChainNav
        commentComponent={<CommentHostory title="Comments" initCommentType={'Factory'} initOrderName={factory?.name ?? ""} />}
      >
        <div>
          <Row>
            <Col className="w-full">
              <Card>
                <CardBody>
                  {
                    factoryState !== 'loading' ? (
                      <div className="mt-4 nguyen441">
                        <Row className="flex-wrap">
                          <Col className="mt-4 sm:w-6/12">
                            <div className="mb-3">
                              <label htmlFor="locationname">Name</label>
                              <Input
                                id="locationname"
                                name="locationname"
                                type="text"
                                className="form-control"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                              />
                            </div>
                            <div className="mb-3">
                              <label htmlFor="locationname">Code</label>
                              <Input
                                id="locationname"
                                name="locationname"
                                type="text"
                                className="form-control"
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                              />
                            </div>

                            {/* Supplier terms (Phase 1) */}
                            <div className="flex gap-3 mb-3">
                              <div>
                                <label>Default currency</label>
                                <select
                                  className="form-control"
                                  value={defaultCurrency}
                                  onChange={(e) => setDefaultCurrency(e.target.value)}
                                >
                                  <option value="">—</option>
                                  {['USD', 'AUD', 'GBP', 'EUR', 'CNY', 'NZD'].map((c) => (
                                    <option key={c} value={c}>{c}</option>
                                  ))}
                                </select>
                              </div>
                              <div>
                                <label>Default incoterm</label>
                                <select
                                  className="form-control"
                                  value={defaultIncoterm}
                                  onChange={(e) => setDefaultIncoterm(e.target.value)}
                                >
                                  <option value="">—</option>
                                  {['FOB', 'FCA', 'EXW', 'CIF', 'DDP'].map((i) => (
                                    <option key={i} value={i}>{i}</option>
                                  ))}
                                </select>
                              </div>
                              <div>
                                <label>Payment terms (days)</label>
                                <Input
                                  type="number"
                                  className="form-control"
                                  value={paymentTermsDays}
                                  onChange={(e) => setPaymentTermsDays(e.target.value)}
                                />
                              </div>
                            </div>

                            <div className="mb-3">
                              <label>Contacts</label>
                              {contacts.map((c, idx) => (
                                <div key={idx} className="flex gap-2 mb-2">
                                  <Input
                                    className="form-control"
                                    placeholder="Name"
                                    value={c.name || ''}
                                    onChange={(e) =>
                                      setContacts(contacts.map((x, i) => (i === idx ? { ...x, name: e.target.value } : x)))
                                    }
                                  />
                                  <Input
                                    className="form-control"
                                    placeholder="Email"
                                    value={c.email || ''}
                                    onChange={(e) =>
                                      setContacts(contacts.map((x, i) => (i === idx ? { ...x, email: e.target.value } : x)))
                                    }
                                  />
                                  <Input
                                    className="form-control"
                                    placeholder="Phone"
                                    value={c.phone || ''}
                                    onChange={(e) =>
                                      setContacts(contacts.map((x, i) => (i === idx ? { ...x, phone: e.target.value } : x)))
                                    }
                                  />
                                  <Button
                                    type="button"
                                    variant="destructive"
                                    onClick={() => setContacts(contacts.filter((_, i) => i !== idx))}
                                  >
                                    ✕
                                  </Button>
                                </div>
                              ))}
                              <Button
                                type="button"
                                variant="outline"
                                onClick={() => setContacts([...contacts, { name: '', email: '', phone: '' }])}
                              >
                                + Add contact
                              </Button>
                            </div>

                            <div
                              style={{
                                margin: '16px 0',
                                background: '#eee',
                                borderRadius: 17,
                                padding: 16,
                              }}
                            >
                              <h6 className='font-medium' style={{ marginBottom: 16 }}>
                                {' '}
                                Factory Address -{' '}
                                <a href="#" onClick={() => setAddressEditModal(true)} className='text-[#1f3dd0]'>
                                  edit
                                </a>
                              </h6>
                              <div> {address?.name || ''} </div>
                              <div> {address?.address1 || ''} </div>
                              <div> {address?.address2 || ''} </div>
                              <div>
                                {' '}
                                {`${address?.city || ''} ${address?.province || ''
                                  } ${address?.zip || ''}`}{' '}
                              </div>
                              <div> {address?.country || ''} </div>
                              <div> {address?.phone || ''} </div>
                            </div>
                          </Col>
                          <Col className="mt-4 w-full">
                            <Accordian close={false} title="Factory Stock Status">
                              <div className="my-4">
                                <div className="mb-2 text-[#1f3dd0]">
                                  <a
                                    href="https://docs.google.com/spreadsheets/d/12www0Rbk6hMuBdyeAKHOMiL99QxxU7PIKVrlqJFqVsE/export?format=csv&id=12www0Rbk6hMuBdyeAKHOMiL99QxxU7PIKVrlqJFqVsE&gid=712857935"
                                    target="_blank"
                                    style={{ cursor: 'pointer' }}
                                  >
                                    CSV Template
                                  </a>
                                </div>
                                <CSVReader
                                  onDrop={handleReleaseCsvDrop}
                                  onError={handleReleaseCsvError}
                                  onRemoveFile={handleReleaseCsvRemove}
                                >
                                  <span>Drop CSV file here or click to upload.</span>
                                </CSVReader>
                                {releaseError && (
                                  <small className="text-danger d-block mt-2">{releaseError}</small>
                                )}
                                <div className="mt-4" />
                              </div>
                              {releaseCsv && (
                                <div className="mt-4 table-responsive">
                                  <table className="table table-bordered table-nowrap">
                                    <thead>
                                      <tr>
                                        {releaseCsv.headers.map((header, index) => (
                                          <th key={`release-header-${index}`}>{header || `Column ${index + 1}`}</th>
                                        ))}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        {releaseCsv.headers.map((_, index) => (
                                          <td key={`release-delivery-${index}`}>
                                            {index === 0 ? (
                                              releaseCsv.deliveryRow[0] || 'Delivery Date'
                                            ) : index === 1 ? (
                                              <Input
                                                type="number"
                                                disabled
                                                className="min-w-[140px]"
                                                value={releaseCsv.deliveryRow[index] ?? ''}
                                              />
                                            ) : (
                                              <Input
                                                type="date"
                                                className="min-w-[170px]"
                                                value={releaseCsv.deliveryRow[index] ?? ''}
                                                onChange={(e) => updateDeliveryCell(index, e.target.value)}
                                              />
                                            )}
                                          </td>
                                        ))}
                                      </tr>
                                      {releaseCsv.rows.map((row, rowIndex) => (
                                        <tr key={`release-row-${rowIndex}`}>
                                          {row.map((cell, columnIndex) => (
                                            <td key={`release-cell-${rowIndex}-${columnIndex}`}>
                                              {columnIndex === 0 ? (
                                                <span>{cell}</span>
                                              ) : (
                                                <Input
                                                  type="number"
                                                  className="min-w-[120px]"
                                                  min={0}
                                                  step="1"
                                                  value={cell ?? ''}
                                                  onChange={(e) => updateReleaseCell(rowIndex, columnIndex, e.target.value)}
                                                />
                                              )}
                                            </td>
                                          ))}
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                              <div className="d-flex justify-content-end mt-4">
                                <Button
                                  type="button"
                                  variant="primary"
                                  className="btn-md"
                                  onClick={submitReleaseData}
                                  disabled={submittingRelease || !releaseCsv}
                                >
                                  {submittingRelease ? 'Submitting...' : 'Submit'}
                                </Button>
                              </div>
                            </Accordian>
                          </Col>
                          <Col className="mt-4 w-full">
                            <Accordian close={loadingSave} title="Stock Produced" >
                              <Row>
                                <Col className="sm:w-11/12" />
                                <Col className="sm:w-1/12" style={{ paddingBottom: 8 }}>
                                  <CSVLink
                                    data={csvData}
                                    filename={`${name}_stock_count.csv`}
                                  >
                                    <Button type="button" variant="secondary" className="btn-lg btn-rounded mt-5">
                                      CSV
                                    </Button>
                                  </CSVLink>
                                </Col>
                              </Row>
                              <StockInput stock={variantLines} setStock={setVariantLines} productData={productData?.data} />
                              <div className="my-4">
                                <CSVReader
                                  onDrop={handleOnDrop}
                                  onError={handleOnError}
                                  onRemoveFile={handleOnRemoveFile}
                                >
                                  <span>Drop CSV file here or click to upload.</span>
                                </CSVReader>
                                <div className="mt-2 d-flex justify-content-center">
                                  <a href="https://docs.google.com/spreadsheets/d/1IKRTd60gREBhUgwmo29U81Scbb_fRLmqpKqO_NPNW1w/copy"> CSV Template </a>
                                </div>
                              </div>
                            </Accordian>
                          </Col>
                        </Row>
                        <Button onClick={handleSave} type="submit" variant="success" className="mr-1 waves-effect waves-light">{loadingSave ? 'Saving...' : 'Save Changes'}</Button>
                        <Row style={{ marginTop: 16 }} className="mb-12">
                          <table className="table mb-0 mt-8">
                            <thead style={{ position: 'sticky', top: 0, background: 'white', }}>
                              <tr>
                                <th>PO Reference</th>
                                <th>SKU</th>
                                <th>On Order</th>
                                <th>On Hand</th>
                              </tr>
                            </thead>
                            <tbody>
                              {!!stockLevels && Object.keys(stockLevels).map(POId => (
                                stockLevels[POId].map(item => (
                                  <tr key={`${POId}-${item.sku}`}>
                                    <td><a href={`/purchase-order/${POId}`} >{item.POReference}</a></td>
                                    <td>{item.sku}</td>
                                    <td>{item.lineQuantity - item.releaseQuantity}</td>
                                    <td>{item?.onHand}</td>
                                  </tr>
                                ))
                              ))}
                            </tbody>
                          </table>

                        </Row>
                      </div>
                    ) : (
                      <div className="spinner-border text-primary m-1" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    )
                  }
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </SupplyChainNav>
      <EditAddressModal
        modal={addressEditModal}
        togglemodal={() => setAddressEditModal(false)}
        address={address}
        setAddress={setAddress}
        title="Edit Factory Address"
      />
    </>
  );
}

export default FactoryPage;
